import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';
import type { Driver } from '../lib/types';

interface UseDriverResult {
  driver: Driver | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useDriver(id: string | undefined): UseDriverResult {
  const [driver, setDriver] = useState<Driver | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);

    const { data, error: err } = await supabase
      .from('drivers')
      .select('*, vehicle:vehicles(*)')
      .eq('id', id)
      .single();

    if (err) {
      setError(err.message);
      setDriver(null);
    } else {
      setDriver(data as Driver);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }
    refetch();
    const unsub = subscribeTable('drivers', refetch, `id=eq.${id}`);
    return unsub;
  }, [id, refetch]);

  return { driver, loading, error, refetch };
}
